import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { VwoService } from '@services/vwo/vwo.service';
import { StoryPaymentComponent } from '../story-payment/story-payment.component';
import { MatButtonModule } from '@angular/material/button';
import { MultiPatientNoteComponent } from '../multi-patient-note/multi-patient-note.component';
import { ImgFallbackDirective } from '@directives/img-fallback/img-fallback.directive';

@Component({
  selector: 'app-mini-story',
  standalone: true,
  imports: [
    NgIf,
    StoryPaymentComponent,
    ImgFallbackDirective,
    MatButtonModule,
    MultiPatientNoteComponent
  ],
  templateUrl: './mini-story.component.html',
  styleUrls: ['./mini-story.component.scss']
})
export class MiniStoryComponent {

  readonly vars = inject(VariablesService);
  readonly util = inject(UtilService);
  readonly actRoute = inject(ActivatedRoute);
  readonly vwo = inject(VwoService);

  @Input() fundraiser;
  @Output() viewMore = new EventEmitter();
  caller_name;
  params;

  ngOnInit() {
    this.params = this.actRoute.snapshot.queryParams;
    this.util.addCssToGlobal('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
    const x = this.params['utm_medium']?.indexOf('_');
    this.caller_name = this.params['utm_medium']?.substr(x + 1);
  }

  getTheaterImg() {
    if (this.params?.mini_story === '2' || this.params?.mini_story === '1') {
      return this.fundraiser?.theater?.cdn_path || this.fundraiser?.leaderboard?.cdn_path;
    } else {
      return this.fundraiser?.theater?.cdn_path;
    }
  }
}
